// extracted by mini-css-extract-plugin
module.exports = {"question":"faq_question__Aaybn","answer":"faq_answer__9LdXU","visible":"faq_visible__6sT6H","icon":"faq_icon__n9D_R","content":"faq_content__ke4u_"};